import * as React from "react";

interface TagListProps {
  TagList: string[];
  searchPageLink: string;
}

export const TagList = (props: TagListProps) => (
  <div className="taglist">
    <div className="taglist__heading">Denna artikel handlar om</div>
    <div className="flex">
      {props.TagList.map((tag) => (
        <a
          key={tag}
          className="taglist__tagitem"
          href={`${props.searchPageLink}?q=${tag}`}
        >
          {tag}
        </a>
      ))}
    </div>
  </div>
);
